import React, { useState, useEffect } from "react";
import Header from "./include/header";
import Footer from "./include/footer";
import LeftPanel from "./include/LeftPanel";
import Global from "../APIConfig";
import axios from "axios";
import { ToastContainer, toast } from '../components/ui/toast';
import AuthUser from "../AuthUser";
import { useNavigate, useParams } from 'react-router-dom';
import { ArrowLeft, Lock, Loader2 } from 'lucide-react';
import PasswordInput from '../components/ui/PasswordInput';


/**
 * PasswordContent — change password form.
 * Used both by the standalone /UpdatePassword page and the /Profile hub tab.
 */
export function PasswordContent() {
    let navigate = useNavigate();
    const { headers1, headers2, logout } = AuthUser();
    const [Password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [Loading, setLoading] = useState(true);
    const [btnLoading, setBtnLoading] = useState(false);

    const items = JSON.parse(localStorage.getItem('user'));
    const handlePassSubmit = () => {
        if (Password == "") {
            toast.warning('Password is Required');
        }
        else if (confirmPassword == "") {
            toast.warning('Confirm Password is Required');
        }
        else if (Password != confirmPassword) {
            toast.warning('Password And Confirm Password Must Be Same');
        }
        else {
            setBtnLoading(true);
            axios({
                method: 'post',
                url: Global.baseUrl + 'ChangeCustomerPassword',
                headers: headers1,
                data: {
                    UniqueId: items.uniqueid,
                    Password: Password
                }
            })
                .then(function (response) {
                    if (response.data.status == 200) {
                        toast.success(response.data.message);
                        setTimeout(() => {
                            navigate('/Customer-Dash');
                        }, 1000);
                    } else {
                        toast.warning(response.data.message);
                    }
                    setBtnLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);
                    setBtnLoading(false);
                    if (error.response.status == 401) {
                        toast.error(error.response.statusText);
                        logout();
                        navigate('/');
                        window.location.reload();
                    }
                });
        }
    }

    return (
        <>
            <div className="px-pagehead">
                <div className="px-pagehead__left">
                    <button className="px-btn px-btn--ghost px-btn--sm" onClick={() => navigate(-1)} aria-label="Go back">
                        <ArrowLeft size={16} />
                    </button>
                    <h2 className="px-pagehead__title">Update Password</h2>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-8 col-lg-6">
                    <div className="px-card">
                        <div className="px-card__head">
                            <span className="px-card__title"><Lock size={16} />Change Password</span>
                        </div>
                        <div className="px-card__body">
                            <div className="px-form-group">
                                <label htmlFor="px-new-pass">Password <span className="px-req">*</span></label>
                                <PasswordInput id="px-new-pass" className="px-input" onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
                            </div>
                            <div className="px-form-group">
                                <label htmlFor="px-confirm-pass">Confirm Password <span className="px-req">*</span></label>
                                <PasswordInput id="px-confirm-pass" className="px-input" onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm Password" />
                            </div>
                            {btnLoading == false ?
                                <button className="px-btn px-btn--primary" onClick={() => handlePassSubmit()}>Submit</button>
                                :
                                <button className="px-btn px-btn--primary" disabled><Loader2 size={15} className="px-spin" /> Submitting…</button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

function UpdatePassword() {
    return (
        <>
            <LeftPanel />
            <main className="px-main">
                <Header />
                <ToastContainer />
                <div className="px-content">
                    <PasswordContent />
                </div>
                <Footer />
            </main>
        </>
    );
}
export default UpdatePassword;
